import { render, staticRenderFns } from "./TambahICD9.vue?vue&type=template&id=07817081"
import script from "./TambahICD9.vue?vue&type=script&lang=js"
export * from "./TambahICD9.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07817081')) {
      api.createRecord('07817081', component.options)
    } else {
      api.reload('07817081', component.options)
    }
    module.hot.accept("./TambahICD9.vue?vue&type=template&id=07817081", function () {
      api.rerender('07817081', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/icd9/TambahICD9.vue"
export default component.exports